<template>
  <material-card
    style="margin-top: 30px"
    scrollable
    :title="$t('components.plancreationwizard.coverage_eligibility')"
    :color="$vuetify.theme.themes.light.secondary"
    icon="rule_folder"
  >
    <v-dialog scrollable v-model="dialogs.edit" persistent max-width="1000">
      <material-card
        :title="$t(benefitRulesFormTitle)"
        :icon="benefitRulesFormIcon"
        :color="formColor"
      >
        <v-card-text v-if="item">
          <v-form ref="form" v-model="valid">
            <v-container fluid fill-height>
              <v-row wrap>
                <v-col cols="12" md="3">
                  <trans-select2
                    v-model="item"
                    propertyName="Coverage"
                    :items="coverage"
                    :label="$t('globals.benefit')"
                    :rules="[$rules.required]"
                    class="required"
                    field="Name"
                    itemValue="Identifier"
                    :displayFunc="
                      (item, str) =>
                        `${str} (${translate2(item, 'Description')})`
                    "
                  ></trans-select2>
                </v-col>
                <v-col cols="12" md="3">
                  <!-- <auto-select
                    :value.sync="item.BenefitStatus"
                    :items="options.Enums.BenefitStatus"
                    :label="$t('globals.status')"
                    :slots="true"
                    :rules="[$rules.required]"
                    class="required"
                    :filter="filterFunc"
                  >
                    <template v-slot:selection="data">
                      {{ $t("enums." + data.item) }}
                    </template>
                    <template v-slot:item="data">
                      <v-list-item-content
                        v-text="$t('enums.' + data.item)"
                      ></v-list-item-content>
                    </template>
                  </auto-select> -->
                  <trans-enum
                    :value.sync="item.BenefitStatus"
                    :items="options.Enums.BenefitStatus"
                    :label="$t('globals.status')"
                    :rules="[$rules.required]"
                    class="required"
                  ></trans-enum>
                </v-col>
                <v-col cols="12" md="3">
                  <!-- <auto-select
                    :value.sync="item.BenefitParty"
                    :items="options.Enums.BenefitParty"
                    :label="$t('headers.benefitrules.benefit_party')"
                    :slots="true"
                    :rules="[$rules.required]"
                    class="required"
                    :filter="filterFunc"
                  >
                    <template v-slot:selection="data">
                      {{ $t("enums." + data.item) }}
                    </template>
                    <template v-slot:item="data">
                      <v-list-item-content
                        v-text="$t('enums.' + data.item)"
                      ></v-list-item-content>
                    </template>
                  </auto-select> -->
                  <trans-enum
                    :value.sync="item.BenefitParty"
                    :items="options.Enums.BenefitParty"
                    :label="$t('headers.benefitrules.benefit_party')"
                    :rules="[$rules.required]"
                    class="required"
                  ></trans-enum>
                </v-col>
              </v-row>
              <v-row wrap>
                <v-card-text>
                  {{ $t("headers.benefitrules.eligibility_criteria") }}
                </v-card-text>
                <v-col cols="12" md="3">
                  <v-checkbox
                    v-model="item.DependsOnHasDependants"
                    :label="
                      $t(
                        'components.plancreationwizard.depends_on_has_dependants'
                      )
                    "
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" md="3">
                  <v-checkbox
                    v-model="item.DependsOnCoverageStatus"
                    :label="
                      $t(
                        'components.plancreationwizard.depends_on_default_coverage_status'
                      )
                    "
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" md="3" v-if="item.DependsOnCoverageStatus">
                  <trans-multi-select2
                    v-model="item.CoverageStatuses"
                    :items="options.Models.FamilyStatus"
                    :label="
                      $t('components.plancreationwizard.coverage_statuses')
                    "
                    field="Name"
                    itemValue="Id"
                    :rules="[$rules.atLeastOne]"
                    class="required"
                  ></trans-multi-select2>
                </v-col>
                <v-col cols="12" md="3" v-if="hasClasses">
                  <v-checkbox
                    v-model="item.DependsOnClass"
                    :label="
                      $t('components.plancreationwizard.depends_on_class')
                    "
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" md="3" v-if="item.DependsOnClass">
                  <v-autocomplete
                    v-model="item.Classes"
                    :items="classesArray"
                    :label="$t('components.plancreationwizard.classes')"
                    multiple
                    :rules="[$rules.atLeastOne]"
                    class="required"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row wrap>
                <v-card-text>
                  {{ $t("components.plancreationwizard.reduction_clauses") }}
                </v-card-text>
                <v-col cols="12">
                  <pbas-data-table
                    ref="reductionClausesTable"
                    :dataProvider="reductionClausesProvider"
                    :rowActions="reductionClausesRowActions"
                    :floatActions="reductionClausesFloatActions"
                    fileNamePrefix="reductionClauses"
                    identifier="reductionClausesTable"
                    @error="error = $event"
                  ></pbas-data-table>
                </v-col>
              </v-row>
              <v-row wrap>
                <v-card-text>
                  {{ $t("components.plancreationwizard.termination_clause") }}
                </v-card-text>
                <v-col cols="12" md="3">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-container pa-0>
                        <v-row no-gutters>
                          <v-col cols="auto">
                            <v-checkbox
                              v-model="item.TerminateOnRetirement"
                              :label="
                                $t('components.plancreationwizard.retirement')
                              "
                            ></v-checkbox>
                          </v-col>
                          <v-col
                            style="margin-top: 20px; margin-left: 3px"
                            cols="auto"
                          >
                            <v-icon v-bind="attrs" v-on="on">help</v-icon>
                          </v-col>
                        </v-row>
                      </v-container>
                    </template>
                    <span>
                      {{
                        $t(
                          "components.plancreationwizard.benefit_rules_retirement_tooltip"
                        )
                      }}
                    </span>
                  </v-tooltip>
                </v-col>
                <v-col cols="12" md="3">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-container pa-0>
                        <v-row no-gutters>
                          <v-col cols="auto">
                            <no-autocomplete-textfield
                              @change="item.TerminateAtAge = $event"
                              :value="item.TerminateAtAge"
                              :label="$t('components.plancreationwizard.age')"
                              type="number"
                              :rules="[$rules.integer]"
                            ></no-autocomplete-textfield>
                          </v-col>
                          <v-col
                            style="margin-top: 20px; margin-left: 3px"
                            cols="auto"
                          >
                            <v-icon v-bind="attrs" v-on="on">help</v-icon>
                          </v-col>
                        </v-row>
                      </v-container>
                    </template>
                    <span>
                      {{
                        $t(
                          "components.plancreationwizard.benefit_rules_age_tooltip"
                        )
                      }}
                    </span>
                  </v-tooltip>
                </v-col>
                <v-col
                  cols="12"
                  md="3"
                  v-if="
                    item.TerminateAtAge !== null &&
                    item.TerminateAtAge !== undefined
                  "
                >
                  <v-checkbox
                    v-model="item.HasAgeEliminationPeriod"
                    :label="
                      $t('components.plancreationwizard.elimination_period')
                    "
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" md="3" v-if="item.HasAgeEliminationPeriod">
                  <no-autocomplete-textfield
                    :value="item.EliminationPeriodDays"
                    @change="item.EliminationPeriodDays = $event"
                    :label="
                      $t('components.plancreationwizard.days_from_birthday')
                    "
                    type="number"
                    :rules="[$rules.integer, $rules.dynamic.maxValue(999)]"
                  ></no-autocomplete-textfield>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="closeBenefitRules">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :disabled="!valid"
            color="primary"
            @click="saveBenefitRulesItem"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog v-model="dialogs.delete" scrollable persistent max-width="400">
      <material-card
        :title="$t('components.plancreationwizard.remove_benefit_rules')"
        :color="$vuetify.theme.themes.light.error"
        icon="remove"
      >
        <v-card-text>
          {{ $t("globals.are_you_sure") }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogs.delete = false">
            {{ $t("globals.cancel") }}
          </v-btn>

          <v-btn color="error" text @click="removeBenefitRulesItem">
            {{ $t("globals.remove") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      scrollable
      v-model="dialogs.reductionClauses"
      persistent
      max-width="800"
    >
      <material-card
        :title="$t(reductionClausesFormTitle)"
        :icon="reductionClausesFormIcon"
        :color="reductionClausesFormColor"
      >
        <v-card-text v-if="reductionClausesItem">
          <v-form ref="reductionClausesForm" v-model="validReductionClauses">
            <v-container fluid fill-height>
              <v-row wrap>
                <v-col cols="12" md="3">
                  <!-- <auto-select
                    :value.sync="reductionClausesItem.ReductionType"
                    :items="options.Enums.ReductionType"
                    :label="$t('headers.reductionclauses.reduction_type')"
                    :slots="true"
                    :rules="[$rules.required]"
                    class="required"
                    :filter="filterFunc"
                  >
                    <template v-slot:selection="data">
                      {{ $t("enums." + data.item) }}
                    </template>
                    <template v-slot:item="data">
                      <v-list-item-content
                        v-text="$t('enums.' + data.item)"
                      ></v-list-item-content>
                    </template>
                  </auto-select> -->
                  <trans-enum
                    :value.sync="reductionClausesItem.ReductionType"
                    :items="options.Enums.ReductionType"
                    :label="$t('headers.reductionclauses.reduction_type')"
                    :rules="[$rules.required]"
                    class="required"
                  ></trans-enum>
                </v-col>
                <v-col
                  cols="12"
                  md="3"
                  v-if="reductionClausesItem.ReductionType === 'Percentage'"
                >
                  <currency-textfield
                    :value="reductionClausesItem.Percentage"
                    @change="reductionClausesItem.Percentage = $event"
                    :label="$t('components.claims_history.header.percentage')"
                    :rules="[$rules.dynamic.maxValue(99.99), $rules.required]"
                    class="required"
                    prefix="%"
                  />
                  <!-- <no-autocomplete-textfield
                    :value="reductionClausesItem.Percentage"
                    @change="reductionClausesItem.Percentage = $event"
                    :label="$t('components.claims_history.header.percentage')"
                    prefix="%"
                    @keydown="currencyKeydown"
                    @keyup="currencyKeyUp"
                    @blur="reductionClausesItemPercentageBlur"
                    :rules="[
                      $rules.dynamic.maxValue(99.99),
                      rules.decimal,
                      $rules.required,
                    ]"
                    class="required"
                  ></no-autocomplete-textfield> -->
                </v-col>
                <v-col
                  cols="12"
                  md="3"
                  v-else-if="
                    reductionClausesItem.ReductionType === 'FlatAmount'
                  "
                >
                  <currency-textfield
                    :value="reductionClausesItem.FlatAmount"
                    @change="reductionClausesItem.FlatAmount = $event"
                    :label="$t('headers.reductionclauses.flat_amount')"
                    :rules="[$rules.required]"
                    class="required"
                  />
                  <!-- <no-autocomplete-textfield
                    :value="reductionClausesItem.FlatAmount"
                    @change="reductionClausesItem.FlatAmount = $event"
                    :label="$t('headers.reductionclauses.flat_amount')"
                    prefix="$"
                    @keydown="currencyKeydown"
                    @keyup="currencyKeyUp"
                    @blur="reductionClausesItemFlatAmountBlur"
                    :rules="[rules.decimal, $rules.required]"
                    class="required"
                  ></no-autocomplete-textfield> -->
                </v-col>
                <v-col cols="12" md="3">
                  <no-autocomplete-textfield
                    :value="reductionClausesItem.Age"
                    @change="reductionClausesItem.Age = $event"
                    :label="$t('components.plancreationwizard.age')"
                    :rules="[$rules.requiredNum]"
                    class="required"
                    type="number"
                  ></no-autocomplete-textfield>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="closeReductionClauses">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :disabled="!validReductionClauses"
            color="primary"
            @click="saveReductionClausesItem"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      v-model="dialogs.deleteReductionClauses"
      scrollable
      persistent
      max-width="400"
    >
      <material-card
        :title="$t('components.plancreationwizard.remove_reduction_clauses')"
        :color="$vuetify.theme.themes.light.error"
        icon="remove"
      >
        <v-card-text>
          {{ $t("globals.are_you_sure") }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color text @click="closeReductionClauses">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="primary" text @click="removeReductionClausesItem">
            {{ $t("globals.remove") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <pbas-data-table
      ref="table"
      :dataProvider="provider"
      :rowActions="rowActions"
      :floatActions="floatActions"
      fileNamePrefix="benefitRules"
      identifier="benefitRulesTable"
      @error="error = $event"
    ></pbas-data-table>
    <error-handler :error="error"></error-handler>
  </material-card>
</template>

<script>
import { mapGetters } from "vuex";
import { InMemoryProvider } from "pbas-vue-components";
import BenefitRulesHeaders from "@/headers/BenefitRules";
import ReductionClausesHeaders from "@/headers/ReductionClauses";
import ErrorHandler from "@/components/ErrorHandler";
import TransSelect2 from "@/components/TransSelect2";
import AutoSelect from "@/components/AutoSelect";
import NoAutocompleteTextfield from "@/components/NoAutocompleteTextfield";
import TransMultiSelect2 from "@/components/TransMultiSelect2";
import { translate2 } from "@/trans2";
import CurrencyTextfield from "@/components/CurrencyTextfield.vue";
import TransEnum from "@/components/TransEnum.vue";

export default {
  components: {
    ErrorHandler,
    TransSelect2,
    AutoSelect,
    NoAutocompleteTextfield,
    TransMultiSelect2,
    CurrencyTextfield,
    TransEnum,
  },
  props: [
    "benefitRules",
    "coverage",
    "hasClasses",
    "classesArray",
    "effectiveDate",
    "disabled",
  ],
  data() {
    return {
      rules: {
        decimal: (v) => {
          if (v === null || v === undefined || v === 0 || v === "") return true;
          return !isNaN(parseFloat(v)) || this.$t("validation.must_be_decimal");
        },
      },
      error: null,
      valid: false,
      dialogs: {
        edit: false,
        delete: false,
        reductionClauses: false,
        deleteReductionClauses: false,
      },
      validReductionClauses: false,
      item: null,
      isNew: false,
      floatActions: [
        {
          name: "addBenefitRules",
          icon: "add",
          color: this.$vuetify.theme.themes.light.success,
          text: "globals.add_new",
          handler: () => {
            this.item = {
              Identifier: Math.random().toString(),
              TerminationClause: {},
            };
            this.isNew = true;
            this.reductionClausesProvider = new InMemoryProvider(
              [],
              this.reductionClausesHeaders
            );
            this.dialogs.edit = true;
          },
          visible: () => !this.disabled,
        },
      ],
      rowActions: [
        {
          name: "editBenefitRules",
          icon: "edit",
          title: "globals.edit",
          handler: (item) => {
            this.item = JSON.parse(JSON.stringify(item));
            this.isNew = false;
            this.reductionClausesProvider = new InMemoryProvider(
              item.ReductionClauses,
              this.reductionClausesHeaders
            );
            this.dialogs.edit = true;
          },
          visible: () => !this.disabled,
        },
        {
          name: "removeBenefitRules",
          icon: "delete",
          title: "globals.remove",
          handler: (item) => {
            this.item = JSON.parse(JSON.stringify(item));
            this.dialogs.delete = true;
          },
          visible: () => !this.disabled,
        },
      ],
      provider: undefined,
      headers: BenefitRulesHeaders,
      reductionClausesItem: null,
      reductionClausesIsNew: false,
      reductionClausesFloatActions: [
        {
          name: "addReductionClauses",
          icon: "add",
          color: this.$vuetify.theme.themes.light.success,
          text: "globals.add_new",
          handler: () => {
            this.reductionClausesItem = {
              Identifier: Math.random().toString(),
            };
            this.reductionClausesIsNew = true;
            this.dialogs.reductionClauses = true;
          },
          visible: () => !this.disabled,
        },
      ],
      reductionClausesRowActions: [
        {
          name: "editReductionClauses",
          icon: "edit",
          title: "globals.edit",
          handler: (item) => {
            this.reductionClausesItem = JSON.parse(JSON.stringify(item));
            this.reductionClausesIsNew = false;
            this.reductionClausesItem.Percentage = (
              parseFloat(this.reductionClausesItem.Percentage) * 100
            ).toFixed(2);
            this.dialogs.reductionClauses = true;
          },
          visible: () => !this.disabled,
        },
        {
          name: "removeReductionClauses",
          icon: "delete",
          title: "globals.remove",
          handler: (item) => {
            this.reductionClausesItem = JSON.parse(JSON.stringify(item));
            this.dialogs.deleteReductionClauses = true;
          },
          visible: () => !this.disabled,
        },
      ],
      reductionClausesProvider: undefined,
      reductionClausesHeaders: ReductionClausesHeaders,
    };
  },
  computed: {
    ...mapGetters("plansMembers", ["options"]),
    benefitRulesFormTitle() {
      return this.isNew
        ? "components.plancreationwizard.create_new_benefit_rule"
        : "components.plancreationwizard.edit_benefit_rule";
    },
    benefitRulesFormIcon() {
      return this.isNew ? "add" : "edit";
    },
    formColor() {
      return this.isNew ? this.$vuetify.theme.themes.light.success : this.$vuetify.theme.themes.light.primary;
    },
    reductionClausesFormTitle() {
      return this.reductionClausesIsNew
        ? "components.plancreationwizard.create_new_reduction_clause"
        : "components.plancreationwizard.edit_reduction_clause";
    },
    reductionClausesFormIcon() {
      return this.reductionClausesIsNew ? "add" : "edit";
    },
    reductionClausesFormColor() {
      return this.reductionClausesIsNew ? this.$vuetify.theme.themes.light.success : this.$vuetify.theme.themes.light.primary;
    },
  },
  watch: {
    benefitRules: {
      handler(v) {
        for (let br of v) {
          if (br.Classes && !Array.isArray(br.Classes)) {
            br.Classes = JSON.parse(br.Classes);
          }
        }
        if (this.provider !== null && this.provider !== undefined) {
          this.provider.items = v;
          this.$refs.table.getDataAsync();
        } else {
          this.provider = new InMemoryProvider(v, this.headers);
        }
      },
    },
    "item.DependsOnCoverageStatus": {
      handler(v) {
        if (!v) {
          if (this.item !== null && this.item !== undefined) {
            this.item.CoverageStatuses = [];
          }
        }
      },
    },
    hasClasses: {
      handler(v) {
        if (!v) {
          if (this.provider !== null && this.provider !== undefined) {
            for (let br of this.provider.items) {
              br.DependsOnClass = false;
              delete br.Classes;
            }
          }
          this.$refs.table.getDataAsync();
          this.$emit("update-benefit-rules", this.provider.items);
        }
      },
    },
    "item.DependsOnClass": {
      handler(v) {
        if (!v) {
          if (this.item !== null && this.item !== undefined) {
            this.item.Classes = [];
          }
        }
      },
    },
    "item.TerminateAtAge": {
      handler(v) {
        if (v === null || v === undefined) {
          if (this.item !== null && this.item !== undefined) {
            this.item.HasAgeEliminationPeriod = false;
          }
        }
      },
    },
    "item.HasAgeEliminationPeriod": {
      handler(v) {
        if (v === null || v === undefined) {
          if (this.item !== null && this.item !== undefined) {
            delete this.item.EliminationPeriodDays;
          }
        }
      },
    },
    classesArray: {
      handler(v) {
        if (v === null || v === undefined) {
          if (this.provider !== null && this.provider !== undefined) {
            for (let br of this.provider.items) {
              br.DependsOnClass = false;
              delete br.Classes;
            }
          }
          this.$refs.table.getDataAsync();
          this.$emit("update-benefit-rules", this.provider.items);
        } else {
          if (this.provider !== null && this.provider !== undefined) {
            for (let rule of this.provider.items) {
              if (rule.Classes !== null && rule.Classes !== undefined) {
                rule.Classes = rule.Classes.filter((o) => v.indexOf(o) > -1);
              }
            }
            // selectedItem.Eligibility.EligibilityPeriodRules
            // selectedItem.Eligibility.CoverageCommencementRules
            // selectedItem.Eligibility.MemberCoverageEligibilityRules
            this.$refs.table.getDataAsync();
            this.$emit("update-benefit-rules", this.provider.items);
          }
        }
      },
    },
  },
  mounted() {
    if (this.benefitRules !== null && this.benefitRules !== undefined) {
      this.provider = new InMemoryProvider(this.benefitRules, this.headers);
    }
  },
  methods: {
    translate2(item, field) {
      console.log(item, field);
      return translate2(item, field);
    },
    saveReductionClausesItem() {
      let item = JSON.parse(JSON.stringify(this.reductionClausesItem));
      item.EffectiveDate = this.effectiveDate;
      if (item.ReductionType === "Percentage") {
        item.Percentage = (parseFloat(item.Percentage) / 100).toFixed(4);
        delete item.FlatAmount;
      } else if (item.ReductionType === "FlatAmount") {
        delete item.Percentage;
      }
      if (this.reductionClausesIsNew) {
        this.addReductionClausesItem(item);
      } else {
        this.updateReductionClausesItem(item);
      }
      // this.saved.reductionClauses = false;
    },
    updateReductionClausesItem(item) {
      let reductionClausesItem;
      reductionClausesItem = this.reductionClausesProvider.items.filter(
        (o) => o.Identifier === item.Identifier
      )[0];

      this.reductionClausesProvider.items[
        this.reductionClausesProvider.items.indexOf(reductionClausesItem)
      ] = item;

      this.closeReductionClauses();
      this.$refs.reductionClausesTable.getDataAsync();
    },
    addReductionClausesItem(item) {
      this.reductionClausesProvider.items.push(item);
      this.closeReductionClauses();
      this.$refs.reductionClausesTable.getDataAsync();
    },
    removeReductionClausesItem() {
      let item = JSON.parse(JSON.stringify(this.reductionClausesItem));
      let reductionClausesItem;
      reductionClausesItem = this.reductionClausesProvider.items.filter(
        (o) => o.Identifier === item.Identifier
      )[0];

      this.reductionClausesProvider.items.splice(
        this.reductionClausesProvider.items.indexOf(reductionClausesItem),
        1
      );
      this.closeReductionClauses();
      this.$refs.reductionClausesTable.getDataAsync();
    },
    closeReductionClauses() {
      this.dialogs.reductionClauses = false;
      this.dialogs.deleteReductionClauses = false;
      this.reductionClausesItem = null;
      if (this.$refs.reductionClausesForm)
        this.$refs.reductionClausesForm.resetValidation();
    },
    saveBenefitRulesItem() {
      let item = JSON.parse(JSON.stringify(this.item));
      item.EffectiveDate = this.effectiveDate;
      item.ReductionClauses = this.reductionClausesProvider.items.filter(
        () => true
      );
      if (!item.HasAgeEliminationPeriod) {
        delete item.EliminationPeriodDays;
      }
      if (!item.DependsOnCoverageStatus) {
        delete item.CoverageStatuses;
      }
      if (!item.DependsOnClass) {
        delete item.Classes;
      }

      item.Coverage = this.coverage.filter(
        (o) => o.Identifier === item.Coverage.Identifier
      )[0];

      if (this.isNew) {
        this.addBenefitRulesItem(item);
      } else {
        this.updateBenefitRulesItem(item);
      }
      // this.saved.benefitRules = false;
      console.log(item);
    },
    updateBenefitRulesItem(item) {
      let benefitRulesItem;
      benefitRulesItem = this.provider.items.filter(
        (o) => o.Identifier === item.Identifier
      )[0];
      const index = this.provider.items.indexOf(benefitRulesItem);

      this.provider.items[index] = item;

      this.closeBenefitRules();
      this.$refs.table.getDataAsync();
      this.$emit("update-benefit-rules", this.provider.items);
    },
    addBenefitRulesItem(item) {
      this.provider.items.push(item);
      this.closeBenefitRules();
      this.$refs.table.getDataAsync();
      this.$emit("update-benefit-rules", this.provider.items);
    },
    removeBenefitRulesItem() {
      let item = JSON.parse(JSON.stringify(this.item));
      let benefitRulesItem;
      benefitRulesItem = this.provider.items.filter(
        (o) => o.Identifier === item.Identifier
      )[0];

      this.provider.items.splice(
        this.provider.items.indexOf(benefitRulesItem),
        1
      );
      this.closeBenefitRules();
      this.$refs.table.getDataAsync();
      this.$emit("update-benefit-rules", this.provider.items);
    },
    closeBenefitRules() {
      this.dialogs.edit = false;
      this.dialogs.delete = false;
      this.item = null;
      if (this.$refs.form) this.$refs.form.resetValidation();
    },
  },
};
</script>

<style></style>
